import React from "react";
import { Link } from 'react-router-dom';
import logo from "../images/logo.png"
import Social from "./social";

export default function Home(){
    return(
        <>
        <div className="home">
            <h1 className="home-title">COLORANTÍ</h1>
            <div className="home-container">
                <div className="inner">
                    <h1 className="home-title-2">MORALLY CODED</h1>
                    <h1 className="home-title-2">TECHNICALLY SOUND</h1>
                    <nav className="home-nav">
                        <a href="https://colorantiservices.godaddysites.com/" className="home-nav-child">WHO WE ARE</a>
                        <Link to="/register" className="home-nav-child">HOW IT WORKS</Link>
                        <a href="https://linktr.ee/coloranti" rel="noreferrer" className="home-nav-child" target="_blank">CONTACT US</a>
                    </nav>
                </div>
                <img src={logo} alt="colorantí logo" className="logo"/>
            </div>
        </div>
        <Social/>
        </>
    )
}